import React from "react";
import SuccessModalIcon from "../../Assets/svg/SuccessModalIcon";
import { CloseIcon } from "../../Assets/svg/CloseIcon";
import ErrorModalIcon from "../../Assets/svg/ErrorModalIcon";
export const AddSuccessModal = ({ view, onClose }) => {
  return (
    <div className="modal modalSuccessfull modal--open">
      <div className="modal__dialog">
        <div className="modal__content">
          <div className="modal__header">
            <div className="icon">
              {view === "document-failure" ? (
                <ErrorModalIcon />
              ) : (
                <SuccessModalIcon />
              )}
            </div>
            <button onClick={onClose} className="btnClose">
              <CloseIcon />
            </button>
          </div>
          <div className="modal__body">
            <p className="para">
              {view === "document"
                ? " Document Uploaded Successfully "
                : view === "document-failure"
                ? "Failed to Upload Document. Please select correct document format"
                : view === "change-request"
                ? "Request sent successfully"
                : `Invite sent successfully to the${" "}
              ${
                view == "client"
                  ? "Client"
                  : view === "advisor"
                  ? "Advisor"
                  : "User"
              }${" "}`}
            </p>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default AddSuccessModal;
